import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { WebStat } from '@miro-site/stats';
var eventHub = null;

var getEventHub = function getEventHub() {
  // skip server side imports
  if (false) {
    return null;
  }

  if (!eventHub) {
    var params = {
      apiHost: "".concat(process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_ENDPOINT, "/v1"),
      apiKey: process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_AUTH
    };
    var handler = WebStat.createStatHandler({
      apiHost: params.apiHost,
      library: 'miro-site/analytics',
      version: '0.0.1',
      addCommonStatParams: function addCommonStatParams(params) {
        return _objectSpread({}, params);
      },
      // eslint-disable-next-line no-console
      sendError: function sendError(err, extra) {
        return console.error(err, extra);
      }
    });
    var methods = {
      identify: function identify(id) {
        WebStat.identify(handler, params.apiKey, {
          id: id,
          name: '',
          email: ''
        });
      },
      page: function page() {
        WebStat.page(handler, params.apiKey);
      },
      track: function track(eventName, properties) {
        var cleanProps = properties; // "properties" can be passed as a string

        if (typeof properties === 'string') {
          var trimmedStringProp = properties.trim();

          if (trimmedStringProp.length > 0) {
            cleanProps = {
              trimmedStringProp: trimmedStringProp
            };
          }
        }

        WebStat.track(handler, params.apiKey, eventName, cleanProps);
      }
    };

    if (!window['analytics']) {
      window['analytics'] = methods;
    }

    eventHub = methods;
  }

  return eventHub;
};

export default getEventHub();